const css = `.OQi3OG__zoomOutButton{background-color:var(--base-surfaces-default-inverse)}.OQi3OG__zoomOverlay{border-left:1px dashed var(--base-surfaces-default-inverse);border-right:1px dashed var(--base-surfaces-default-inverse);position:absolute}.OQi3OG__zoomOverlay:after{content:"";width:100%;height:100%;background-color:var(--base-surfaces-default-inverse);opacity:.16;display:block}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"zoomOutButton":"OQi3OG__zoomOutButton","zoomOverlay":"OQi3OG__zoomOverlay"};
